"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var ModalIcon_1 = __importDefault(require("./ModalIcon"));
var NewModalHeaderWrapper = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        paddingBottom: theme.spacing(2),
        textAlign: 'center',
    });
});
var NewModalHeader = function (_a) {
    var icon = _a.icon, iconColor = _a.iconColor, title = _a.title, subTitle = _a.subTitle, subTitleTextAlign = _a.subTitleTextAlign;
    return ((0, jsx_runtime_1.jsxs)(NewModalHeaderWrapper, __assign({ textAlign: "center" }, { children: [icon && (0, jsx_runtime_1.jsx)(ModalIcon_1.default, { color: iconColor, icon: icon }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, fontWeight: 600, mt: 3, mb: 2 }, { children: title })), subTitle && (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ color: "riverstone", pb: 0.25, whiteSpace: "break-spaces", textAlign: subTitleTextAlign }, { children: subTitle }))] })));
};
exports.default = NewModalHeader;
